import { useState } from "react";
import { Form, Modal, Button, Alert } from "react-bootstrap";
/**
 *
 * @param {{
 * show:boolean,
 * onHide:()=>void,
 * submitClick:(formData:FormData)=>void,
 * multiple?:boolean
 * }} props
 * @returns {JSX.element}
 */
function ModalUploadFile2({ show, onHide, submitClick, multiple = false }) {
  const [formData, setFormData] = useState(null);
  const [fileName, setFileName] = useState(null);

  const handleSubmit = () => {
    submitClick(formData);
    setFormData(null);
    setFileName(null);
  };

  const handleChange = (e) => {
    const files = e.target.files;
    const data = new FormData();
    if (multiple) {
      Array.from(files).forEach((file) => {
        data.append("files[]", file);
      });
    } else {
      data.append("file", files[0]);
    }

    setFormData(data);
    setFileName(files[0]?.name);
  };

  const handleClose = () => {
    setFormData(null);
    setFileName(null);
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Upload File</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group controlId="formFile" className="mb-3">
          <Form.Control type="file" onChange={handleChange} multiple={multiple} />
        </Form.Group>

        <Alert variant="info">Please select a file to upload.</Alert>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" onClick={handleSubmit} className="btn btn-outline-theme" disabled={!fileName}>
          Save changes
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalUploadFile2;
